import fetch from '../../utils/fetch'

export function confirmTicket(params) {
    return fetch({
        url: '/api/ticket/ChinaUnionticket',
        method: 'POST',
        data: params
    })
}
export function NuoConfirmTicket(params) {
    return fetch({
        url: '/api/ticket/nuoNuoUnionticket ',
        method: 'POST',
        data: params
    })
}
export function jLConfirmTicket(params) {
    return fetch({
        url: '/api/ticket/Jlticket',
        method: 'POST',
        data: params
    })
}
